import { useGameStore } from '../../store/gameStore';
import { useAutoConfirm } from '../../hooks/useAutoConfirm';
import styles from './DiceChoice.module.css';

export default function DiceChoice() {
  const turnPhase = useGameStore(s => s.turnPhase);
  const _diceOptionHigh = useGameStore(s => s._diceOptionHigh);
  const _diceOptionLow = useGameStore(s => s._diceOptionLow);
  const chooseDiceSteps = useGameStore(s => s.chooseDiceSteps);
  const diceResult = useGameStore(s => s.diceResult);

  const isActive = turnPhase === 'diceChoice' && _diceOptionHigh !== null && _diceOptionLow !== null;

  const handleChoose = (steps: number) => {
    chooseDiceSteps(steps);
  };

  // Hook 必须在任何 return 之前调用（React 规则）
  // enabled: false 时 hook 内部不启动倒计时
  useAutoConfirm({
    onAutoConfirm: () => {
      if (_diceOptionHigh !== null) handleChoose(_diceOptionHigh);
    },
    delayMs: 10000,
    enabled: isActive,
  });

  if (!isActive) return null;

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <div className={styles.header}>
          <span className={styles.icon}>🎲</span>
          <span className={styles.title}>双骰抉择</span>
        </div>
        <p className={styles.subtitle}>选择你想要的步数前进</p>

        <div className={styles.diceRow}>
          <div className={styles.diceDisplay}>
            <span className={styles.diceValue}>{diceResult?.[0] ?? '?'}</span>
          </div>
          <span className={styles.sep}>·</span>
          <div className={styles.diceDisplay}>
            <span className={styles.diceValue}>{diceResult?.[1] ?? '?'}</span>
          </div>
        </div>

        <div className={styles.choices}>
          <button
            className={`${styles.btn} ${styles.btnHigh}`}
            onClick={() => handleChoose(_diceOptionHigh!)}
          >
            <span className={styles.btnLabel}>取高</span>
            <span className={styles.btnSteps}>{_diceOptionHigh} 步</span>
          </button>
          <button
            className={`${styles.btn} ${styles.btnLow}`}
            onClick={() => handleChoose(_diceOptionLow!)}
          >
            <span className={styles.btnLabel}>取低</span>
            <span className={styles.btnSteps}>{_diceOptionLow} 步</span>
          </button>
        </div>
      </div>
    </div>
  );
}
